export const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'most_views', label: 'Most Views' },
  { value: 'least_views', label: 'Least Views' },
]

export const AUTH_REQUIRED_PAGES = ['/', '/settings']
